import { memo } from "react";
import { Link, Tooltip } from "@mui/material";

import { useNotificationContext } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";

const translationPath = "chatBot.page.register.ticketService.";

interface ITicketServiceIdProps {
  data: string;
}
const TicketServiceid: React.FC<ITicketServiceIdProps> = ({ data }) => {
  const { setMessage } = useNotificationContext();
  const { t } = useTranslation();

  const onClickHandler = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    navigator.clipboard.writeText(data);
    setMessage({
      message: t(translationPath + "copied_successfully"),
      type: "success",
    });
  };

  return (
    <Tooltip title={data}>
      <Link
        component="button"
        variant="body2"
        onClick={onClickHandler}
        textOverflow={"ellipsis"}
        overflow={`hidden`}
      >
        {data}
      </Link>
    </Tooltip>
  );
};

export default memo(TicketServiceid);
